export enum DeliveryPlanType {
    Draft = 0,
    Published = 1,
}